'use strict';

class Appointment {
    constructor(title, start, end, id) {
        this.title = title;
        this.start = start;
        this.end = end;
        this.id = id
    }
}

export var appointmentConverter = {
    toFirestore: function (appointment) { // firebase.firestore.DocumentData 
        return {
            title: appointment.title,
            startAt: appointment.start,
            endAt: appointment.end,
            id: appointment.id
        }
    },
    fromFirestore: function (snapshot, options) { //firebase.firestore.QueryDocumentSnapshot,
        // options: firebase.firestore.SnapshotOptions): Appointment {
        const data = snapshot.data(options);
        console.log('fromFirestore, appont. on ', data.date);
        let start = data.date ? new Date(data.date.seconds * 1000) : null;
        let end = new Date(start.getTime());
        if (end && start) {
            let duration = data.treatment?.duration || 0;
            end.setTime(start.getTime() + (duration * 60 * 1000));
        }
        console.log("start and end", start, end);
        return new Appointment(data.treatment?.name, start, end, data.id);
    }

}